import React, { useEffect, useState } from "react";
import images from "../../../assets/images/constantImages";
import icons from "../../../assets/images/constantIcons";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import EditCustomerForm from "./EditCustomerForm";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import apiService, { formatRupees, handleError} from "../../Common/ApiCommon/ApiService";
import PayNowPlayer from "./PayNowPlayer";
import { Form, Formik } from "formik";
import PlayerBookings from "./PlayerBookings";


const ViewCustomer = () => {
  const [customer, setCustomerData] = useState([]);
  const [OpenPopup, setOpenPopup] = useState(false);
  const [editPopup, setEditPopup] = useState(false);
  const [customerStatus, setCustomerStatus] = useState(null);
  const { id } = useParams();
  const [initialLoading, setInitialLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPaynow, setIsPaynow] = useState(null);
  const [profileUpdate, setProfileUpdate] = useState(false);
  const [image, setImage] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const password = location.state?.password;

  const getInitials = (fullName) => {
    if (!fullName) return "";
    const nameParts = fullName.trim().split(" ");
    if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
    return (nameParts[0][0] + nameParts[1][0]).toUpperCase();
  };

  // Get the customer data by id
  const fetchCustomers = async () => {
    setInitialLoading(true);
    try {
      const response = await apiService.get(`/customer_users/${id}?password=${password}`);
      setCustomerData(response.data);
      setCustomerStatus(response.data.status === "activated"); // Update status
    } catch (errors) {
      handleError(errors);
    } finally {
      setInitialLoading(false);
    }
  };

  // Call the function inside `useEffect`
  useEffect(() => {
    if (id) {
      fetchCustomers();
    }
  }, [id]);

  // update profile image

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleUpdateProfileImage = async () => {
    try {
      if (!image) return;
      const formData = new FormData();
      formData.append("customer_user[image]", image);
      const response = await apiService.put(`/customer_users/${id}`, formData);
      setCustomerData((prev) => ({ ...prev, image: response.data.image }));
      toast.success("Profile image updated successfully!");
      setProfileUpdate(false);
    } catch (errors) {
      handleError(errors);
    }
  };

  const fullImageUrl = customer?.image
    ? `https://headquater.pixoatic.com${customer.image}`
    : images.defaultprofilepicture;

  const handleEditPopup = () => {
    setEditPopup(!editPopup);
  };

  const closeModal = () => {
    setOpenPopup(false);
    setEditPopup(false);
  };
  const handleOpenPay = () => {
    setIsPaynow(!isPaynow);
  };
  // Formik for the Set Credit Limit form
  const formik = useFormik({
    initialValues: {
      due_limit: "",
    },
    validationSchema: Yup.object({
      due_limit: Yup.number()
        .required("Amount is required")
        .min(1, "Amount must be greater than 0"),
    }),
    onSubmit: async (values) => {
      setIsSubmitting(false);
      try {
        const { due_limit } = values;
        const formattedData = {
          customer_user: {
            due_limit,
          },
        };
        const response = await apiService.put( `/customer_users/${id}`,  formattedData );
        if (response.status === 200) {
          closeModal();
          toast.success("Credit limit updated successfully ", { duration: 2000});
          fetchCustomers();
        }
      } catch (errors) {
        handleError(errors);
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  const transactioncard = [
    {
      heading: "Dues",
      price: formatRupees(customer?.amount),
      imageicon: images.rupee,
    },
    {
      heading: "Amount Paid",
      price: formatRupees(customer?.amount_paid),
      imageicon: images.rupee,
    },
    {
      heading: "Amount spent",
      price: formatRupees(customer?.amount_spent),
      imageicon: images.rupee,
    },
    {
      heading: "Credit limit",
      price: formatRupees(customer?.due_limit),
      imageicon: images.winner,
    },
    {
      heading: "Looser",
      price: customer?.loose,
      imageicon: images.games,
    },
    {
      heading: "Winner",
      price: customer?.winner,
      imageicon: images.winner,
    },
  ];

  // customer details
  const playerDetails = [
    { label: "Contact", value: customer?.mobile_no },
    { label: "Email", value: customer?.email || "N/A" },
    { label: "Date of birth ", value: customer?.dob || "N/A" },
    { label: "City", value: customer?.city },
    { label: "Credit Limit", value: formatRupees(customer?.due_limit || 0) },
  ];

  const amountValue = parseFloat(customer?.amount?.replace(/[^\d.-]/g, "")) || 0;
  const isAddAmount = amountValue <= 0;

  if (initialLoading) {
    return <>Loading ...</>;
  }

  return (
    <div className="px-4 py-4 flex flex-col">
      <div className="flex justify-between mb-3 lg:mb-6">
        <div>
          <Link to="/mainDashboard/customer">
          <icons.IoMdArrowRoundBack className=" cursor-pointer text-green text-2xl font-extrabold"
          />
          </Link>
        </div>
        <div className="flex gap-2 xs:gap-4">
          <button
            className="bg-mintcolor text-white font-medium text-sm md:text-base px-3 py-[6px] rounded-lg"
            onClick={handleOpenPay}
          >
            {isAddAmount ? "Add Amount" : "Pay Due Amount"}
          </button>
          {isPaynow && (
            <PayNowPlayer
              isOpen={handleOpenPay}
              onClose={() => handleOpenPay(null)}
              dueamount={amountValue}
              customerId={id}
              fetchCustomers={fetchCustomers}
            />
          )}

          <Link
            to={`/mainDashboard/customer/viewCustomer/paymenthistory/${id}`}
            state={{ amount: customer?.amount, full_name: customer?.full_name }}
          >
            <button className="bg-mintcolor text-white font-medium text-sm md:text-base px-1 xs:px-3 py-[6px] rounded-lg">
              Payment History
            </button>
          </Link>
        </div>
      </div>

      {/* customer details */}
      <div className="flex flex-col md:flex-row  gap-5 lg:gap-7 ">
        <div className="w-full xs:w-[70%] md:w-[40%] xl:w-1/3 bg-white shadow-sm  px-8 py-3 md:p-6 rounded-3xl">
          <div className="flex flex-col gap-3 items-center">
            <div className="relative">
              {customer?.image ? (
                <img
                  src={fullImageUrl}
                  alt="Profile"
                  onError={() =>
                    setCustomerData((prev) => ({ ...prev, image: null }))
                  }
                  className="w-[100px] h-[100px] object-cover rounded-full border-2 border-white shadow-xl mb-4"
                />
              ) : (
                <div className="w-[100px] h-[100px] flex items-center justify-center bg-blueButton text-white text-2xl font-semibold rounded-full border-2 border-white shadow-xl mb-4">
                  {getInitials(customer?.full_name)}
                </div>
              )}
              <div
                onClick={() => setProfileUpdate(true)}
                className="flex justify-center items-center w-9 h-9 p-1 bg-green50 rounded-full absolute bottom-5 right-0 border border-white cursor-pointer"
              >
                <icons.TbEdit className="text-green text-2xl" />
              </div>
            </div>

            {/* Image Upload Modal */}
            {profileUpdate && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <div className="bg-white rounded-lg p-6 w-[350px] md:w-[460px] relative">
                  <div className="flex justify-between items-center mb-4">
                    <h2 className="text-lg font-semibold text-G500">
                      Update Profile Image
                    </h2>
                    <div
                      className="absolute top-7 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px]"
                      onClick={() => setProfileUpdate(false)}
                    >
                      <icons.IoClose className="text-green700" />
                    </div>
                  </div>
                  <Formik
                    initialValues={{ image: null }}
                    onSubmit={handleUpdateProfileImage}
                  >
                    {({ setFieldValue, isSubmitting }) => (
                      <Form className="flex flex-col">
                        <div className="flex flex-col items-center">
                          <img
                            src={
                              image ? URL.createObjectURL(image) : fullImageUrl
                            }
                            alt="Preview"
                            className="w-32 h-32 object-cover rounded-full mb-2 border"
                          />
                        </div>
                        <label className="cursor-pointer text-G300 text-sm mb-2">
                          Upload Image
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          className="text-sm inputtext"
                          onChange={handleImageChange}
                        />
                        <div className="flex justify-end space-x-4 pt-4">
                          <button
                            type="button"
                            onClick={() => setProfileUpdate(false)}
                            className="w-[93px] text-sm py-2 border border-green text-green rounded-lg"
                          >
                            Close
                          </button>
                          <button
                            type="submit"
                            className={`w-[93px] text-sm py-2 rounded-lg ${
                              isSubmitting
                                ? "bg-green50 cursor-not-allowed"
                                : "bg-green text-white"
                            }`}
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? "Updating..." : "Update"}
                          </button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            )}
            <h1 className="text-G500 text-[16px] font-medium">
              {customer?.full_name}
            </h1>
            <button
              className={`w-auto px-4 py-2 rounded-[32px] font-medium
    ${
      customer?.status === "activated"
        ? "text-purple bg-purple bg-opacity-[10%]" 
        : "text-red bg-red bg-opacity-[10%]" 
    }`}
            >
              {customer?.status === "activated" ? "Active" : "Deactive"}
            </button>
          </div>
          <div className="flex justify-center lg:justify-start">
            <div className="flex flex-col items-start gap-2 my-5">
              {playerDetails?.map((detail, index) => (
                <div className="flex gap-2 text-sm text-G300" key={index}>
                  <h1 className="font-medium"> {detail.label}:</h1>
                  <p className="font-normal ">{detail.value}</p>
                </div>
              ))}
            </div>
          </div>
          <button
            onClick={handleEditPopup}
            className="w-full py-2 bg-green text-white text-center text-[16px] rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
            disabled={customer?.status === "deactivated"}
          >
            Edit details
          </button>
          <EditCustomerForm
            editPopup={editPopup}
            onClose={handleEditPopup}
            customerId={id}
            fetchCustomers={fetchCustomers}
            password={password}
          />
        </div>
        <div className="w-full md:w-[60%] xl:w-2/3 ">
          <div className="grid grid-cols-2 xl:grid-cols-3 gap-2 xs:gap-4">
            {transactioncard.map((cards, index) => (
              <div
                className={`lg:h-[100px] flex items-center justify-between rounded-2xl px-4 py-2 lg:p-4 bg-white border border-G30`}
                key={index}
              >
                <div className="flex flex-col  text-G500 font-medium">
                  <p className="text-sm md:text-base lg:text-xl ">
                    {cards.price}
                  </p>
                  <h1 className="text-xs xs:text-sm">{cards.heading}</h1>
                </div>
                <div className="w-[30px] h-[30] md:w-[40px] md:h-[40px] lg:w-[62px] lg:h-[62px] bg-green50 flex justify-center items-center rounded-xl">
                  <img
                    src={cards.imageicon}
                    alt="transactionlogo"
                    className="w-[24px] h-[24px] object-cover"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* set credit limit popup  */}
      {OpenPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] h-auto relative">
            <div
              className="absolute top-7 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px]"
              onClick={() => {
                formik.resetForm();
                closeModal();
              }}
            >
              <icons.IoClose className="text-green700" />
            </div>

            <h2 className="text-xl font-semibold mb-6 text-G500">
              Set credit limit
            </h2>
            <p className="text-sm font-medium mb-4 text-G500">
              Current limit ₹ 999
            </p>
            <form onSubmit={formik.handleSubmit} className="space-y-4">
              <div className="text-G300">
                <label className="block text-sm font-normal mb-2">Amount</label>
                <input
                  type="number"
                  name="due_limit"
                  value={formik.values.due_limit}
                  onChange={formik.handleChange}
                  onWheel={(e) => e.target.blur()} // Prevents changing value on scroll
                  onBlur={formik.handleBlur}
                  className="inputtext"
                  placeholder="Amount"
                />
                {formik.errors.due_limit && formik.touched.due_limit && (
                  <div className="text-red text-sm">
                    {formik.errors.due_limit}
                  </div>
                )}
              </div>
              <div className="flex justify-end space-x-4 pt-4">
                <button
                  type="button"
                  onClick={() => {
                    formik.resetForm();
                    closeModal();
                  }}
                  className="w-[75px] sm:w-[93px] text-sm py-2 text-center border border-green text-green rounded-lg"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className={`w-[75px] sm:w-[93px] text-sm text-center py-2 rounded-lg ${
                    isSubmitting
                      ? "bg-green50 cursor-not-allowed"
                      : "bg-green text-white"
                  }`}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
   <PlayerBookings/>
    </div>
  );
};

export default ViewCustomer;
